<template>
    <a id="restaurants-list-top"></a>
    <div class="site-frame pt-8 sm:pt-10 md:pt-12 lg:pt-14">
        <div class="container-lg">
            <RestaurantsListFilters />
        </div>
    </div>

    <div class="site-frame bg-white">
        <div class="container-sm">
            <RestaurantsListHeader />
            <RestaurantsListResults />
            <RestaurantsListPagination />
        </div>
    </div>
</template>

<script setup>
import { provide } from 'vue';
import RestaurantsListFilters from './RestaurantsListFilters.vue';
import RestaurantsListHeader from './RestaurantsListHeader.vue';
import RestaurantsListPagination from './RestaurantsListPagination.vue';
import RestaurantsListResults from './RestaurantsListResults.vue';

const props = defineProps({ dashboardApiBase: { type: String, required: true }});

provide('dashboardApiBase', props.dashboardApiBase);
</script>
